//
// SearchPage.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import Content from '../components/Content'
import Header from '../components/Header'
import Footer from '../components/Footer'

class SearchPage extends React.Component {
    render() {
        const name = this.props.match.params.name;
        const searchDataOpen = new Buffer(name, 'base64').toString('utf8'); //utf8 //ascii
        return (
            <div>
                <Header content='Search' search={searchDataOpen} />
                <Content content='Search' search={searchDataOpen}/>
                <Footer />     
            </div>
        )
    }
}

export default SearchPage;

